import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { InvoiceService } from "../../invoice.service";
import moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-invoice-set-as-payed",
  template: `
    <button [ngbTooltip]="'ALERT.CONFIRM_CASHED_BTN' | translate" has_capability="set_paid_invoice" (click)="modalOpen()" type="button" class="bg-transparent border-0">
      <i class="text-success" [data-feather]="'dollar-sign'" size="19"></i>
    </button>
    <ng-template #closeCommissionModal let-modal>
      <div>
        <div class="modal-header">
          <div></div>
        </div>
        <div class="modal-body" tabindex="0">
          <h3>{{ "SET_INVOICE_AS_CASHED" | translate }}</h3>
          <div class="form-group mt-2">
            <label [for]="'close_date'">{{ "CASHED_DATE" | translate }}<sup class="text-danger">*</sup></label>
            <app-datepickr id="close_date" [defaultDate]="closeDate" [maxDate]="today" (onSelect)="closeDate = $event"></app-datepickr>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
          <button class="btn btn-primary w-150" (click)="handlerClick()" rippleEffect> {{ "SEND" | translate }}</button>
        </div>
      </div>
    </ng-template>
  `,
})
export class InvoiceSetAsPayedComponent {
  @Input() invoice_id: number;
  @Output() onSetAsPayed = new EventEmitter();
  @ViewChild("closeCommissionModal") closeCommissionModal: any;

  today: string = moment().add(1, 'day').format("YYYY-MM-DD");
  closeDate: string = moment().format("YYYY-MM-DD");

  constructor(private _modalService: NgbModal, private invoiceService: InvoiceService) {
  }

  modalOpen() {
    this._modalService.open(this.closeCommissionModal, { centered: true, size: "sm" });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.closeDate = null;
  }

  async handlerClick() {
    this.invoiceService.setPayed(this.invoice_id, this.closeDate)
      .subscribe(() => {
        this.modalClose();
        this.onSetAsPayed.emit();
      });
  }
}
